export default "__VITE_ASSET__4_tY1g4S4ewTPtt3KIxpYg__";